export default {
  title: 'Vero ja valuutta',
  subtitle: 'Hallitse veroluokkia, joita käytetään ruokalistasi tuotteiden hinnoittelussa.',
};
